import { TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MomentModule } from 'ngx-moment';

import { RtiIntegrationsModule } from '@core/integrations-legacy';
import { PhoneNumberPipe } from '@core/user-interface-legacy';

@NgModule({
  imports: [MomentModule, RouterModule, RtiIntegrationsModule, TitleCasePipe],
  exports: [],
  providers: [PhoneNumberPipe],
})
export class CandidatesTableModule {}
